import { useTranslation } from "@opendash/i18n";
import { Tour, TourProps } from "antd";
import React, { useState } from "react";
import { useUserGuideSelect } from "../../../hooks/useUserGuideSelect";
import { TourId } from "../../../types/TourId";
import TourButton from "../TourButton";

export default () => {
  const t = useTranslation();
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const select = useUserGuideSelect<TourId.Trip>();

  const steps: TourProps["steps"] = [
    {
      title: t("gtfs:tour.trip.start.title"),
      description: t("gtfs:tour.trip.start.description"),
    },
    {
      title: t("gtfs:tour.trip.create.title"),
      description: t("gtfs:tour.trip.create.description"),
      target: select(TourId.Trip.create),
      onNext: () => {
        select(TourId.Trip.create)?.click();
        setTimeout(() => {
          setCurrent((prev) => prev + 1);
        }, 500);
      },
    },
    {
      title: t("gtfs:tour.trip.modal.title"),
      description: t("gtfs:tour.trip.modal.description"),
      target: select(TourId.Trip.modal),
      onPrev: () => {
        select(TourId.Trip.close)?.click();
        setCurrent((prev) => prev - 1);
      },
    },
    {
      title: t("gtfs:tour.trip.save.title"),
      description: t("gtfs:tour.trip.save.description"),
      target: select(TourId.Trip.save),
      onNext: () => {
        select(TourId.Trip.close)?.click();
        select(TourId.Trip.card)?.setAttribute("style", "display: table-row");
        setCurrent((prev) => prev + 1);
      },
    },
    {
      title: t("gtfs:tour.trip.overview.title"),
      description: t("gtfs:tour.trip.overview.description"),
      target: select(TourId.Trip.card),
      onPrev: () => {
        select(TourId.Trip.create)?.click();
        select(TourId.Trip.card)?.setAttribute("style", "display: none");
        setTimeout(() => {
          setCurrent((prev) => prev - 1);
        }, 500);
      },
      onNext: () => {
        select(
          TourId.Trip.overview + " .ant-table-row-expand-icon-cell > a"
        )?.click();
        setTimeout(() => {
          setCurrent((prev) => prev + 1);
        }, 500);
      },
    },
    {
      title: t("gtfs:tour.trip.stops.title"),
      description: t("gtfs:tour.trip.stops.description"),
      target: select(TourId.Trip.stops),
      onNext: () => {
        select(
          TourId.Trip.overview + " .ant-table-row-expand-icon-cell > a"
        )?.click();
        select(TourId.Trip.card)?.setAttribute("style", "display: none");
        setCurrent((prev) => prev + 1);
      },
      onPrev: () => {
        setCurrent((prev) => prev - 1);
        select(
          TourId.Trip.overview + " .ant-table-row-expand-icon-cell > a"
        )?.click();
      },
    },
    {
      title: t("gtfs:tour.trip.end.title"),
      description: t("gtfs:tour.trip.end.description"),
      onPrev: () => {
        setCurrent((prev) => prev - 1);
        select(TourId.Trip.card)?.setAttribute("style", "display: table-row");
        select(
          TourId.Trip.overview + " .ant-table-row-expand-icon-cell > a"
        )?.click();
      },
    },
  ];

  function onEndTour() {
    setOpen(false);
    setCurrent(0);
  }

  return (
    <>
      <TourButton
        onClick={() => setOpen(true)}
        title={t("gtfs:tour.trip.button.title")}
      />
      <Tour
        steps={steps}
        open={open}
        onClose={() => onEndTour()}
        current={current}
        onChange={(cur) => setCurrent(cur)}
      />
    </>
  );
};
